import { Button, Result } from 'antd'
import Container from 'components/Container'
import styled, { css } from 'styled-components'
import { color, margin } from 'theme/mixins'

const ServiceButton = styled(Button)`
	width: 100%;
	height: auto;
	display: inline-flex;
	align-items: center;

	img {
		margin-right: ${margin('sm')};
		width: 30px;
		height: 30px;
	}
`

const TagContainer = styled(Container)`
	display: flex;
	align-items: center;
	position: absolute;
	top: 2px;
	right: 2px;
`

const VezgoContainer = styled('iframe')<{ $loaded: boolean }>`
	border: none;
	${({ $loaded }) =>
		$loaded
			? css`
					min-height: 740px;
			  `
			: css`
					height: 0;
			  `}
`

const ErrorContainer = styled(Result)`
	svg {
		fill: ${color(['error', '300'])};
		margin-right: ${margin('xs')};
	}
`

export default { ServiceButton, TagContainer, VezgoContainer, ErrorContainer }
